import * as z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { ForbearanceCancellationReason } from '../../../loan/WorkoutPlan';
import { zodBrandedUuid } from '../../../utils/Zod';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const ScheduleForbearanceWorkoutPlanCancellationEvent = BaseLoanEvent.extend({
  type: z.literal('scheduleForbearanceWorkoutPlanCancellation'),
  workoutPlanId: zodBrandedUuid<WorkoutPlanId>(),
  reason: ForbearanceCancellationReason,
  terminationDate: z.date(),
});
export type ScheduleForbearanceWorkoutPlanCancellationEvent = z.infer<
  typeof ScheduleForbearanceWorkoutPlanCancellationEvent
>;
